//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import {
  setNavigationSiteCorePageContent,
  setUserRolesAndPermissions,
} from "../redux/slices/appState/appStateSlice";

import { CandidatePageActions } from "../candidatePageActions";
import { Context } from "../common/context/Context";
// import Settings from "../components/Settings";
import AppLayout from "../components/appLayout/AppLayout";

const Dashboard = () => {
  // const children = [{}]
  const context = useContext(Context);
  const dispatch = useDispatch();
  const [permissionPages, setPermissionPages] = useState([]);
  const [errorAlert, setErrorAlert] = useState({
    showAlert: false,
  });
  const showErrorModal = () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
    refErrorMessageAlert.showAlert = false;
    setErrorAlert(refErrorMessageAlert);
  };

  const getRolePermissions = () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetRolePermissions().then(
      (res) => {
        // console.log("gl-permissions:", res.data)
        if (res.status === 200 || res.status === 204) {
          handleRolePermissionsSuccess(res.data);
        }
        if (res.status === 403) {
          context.setIsUserActive(false);
          context.setAdminUser(false);
        } else {
          showError(refErrorMessageAlert);
        }
      },
      (err) => {
        console.log(err);
      },
    );
  };

  function handleRolePermissionsSuccess(resData) {
    let pagesList = resData && [...resData?.permissionPages]; // clone array to make it mutable
    dispatch(setUserRolesAndPermissions(resData));
    /**manually pushing RTI_setUp to permission array */
    pagesList.push(["Client Portal Setup"]);

    // console.log("gl-pagePert", pagesList)
    pagesList?.length > 0
      ? context.setAdminUser(true)
      : context.setAdminUser(false);
    let isUserActive = resData && resData?.isUserActive;
    isUserActive == true
      ? context.setIsUserActive(true)
      : context.setIsUserActive(false);
    let dashBoardIndex = pagesList.indexOf("Dashboard");
    [pagesList[dashBoardIndex], pagesList[0]] = [
      pagesList[0],
      pagesList[dashBoardIndex],
    ];
    setPermissionPages(pagesList && pagesList);

    let permissionComponents = resData?.permissions?.map((item) => {
      return item.trim();
    });
    // console.log("gl-comp", permissionComponents)
    context.setPermissionsList(permissionComponents);
  }
  function showError(refErrorMessageAlert) {
    refErrorMessageAlert.showAlert = true;
    setErrorAlert(refErrorMessageAlert);
    window.scrollTo(0, 0);
  }

  // function for fetching the navigation cmd content
  const getAdminNavigationCMSContent = async (language) => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
    const payload = { pagename: "Navigation", language: language };
    await CandidatePageActions.getAdminCandidateCMSContent(payload).then(
      (res) => {
        if (res.status == 200 || res.status == 204) {
          const data = res.data;
          data.Pages.forEach((el) => {
            if (el.Key === "Navigation") {
              context.setAdminNavigationCmsData(el);
              //store navigation data in redux
              dispatch(setNavigationSiteCorePageContent(data));
            }
          });
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.sessionStorage.getItem("AccessToken") !== null) {
      getRolePermissions();
    }
  }, []);

  return (
    <AppLayout handlePreferredLanguageChange={getAdminNavigationCMSContent}>
      <Outlet />
    </AppLayout>
  );
};

export default Dashboard;
